const STATIC_FILTER = {
  listaSelecionada: [],
  selectedEstados: [],
  selectedMunicipios: [],
  selectedBairros: [],
  selectedDDD: [],
  selectedDocumento: [],
  selectedTagOrigem: [],
  nomeConsumidor: null,
  selectedMesNascimento: [],
  selectedProfissao: [],
  listCategoria1: [],
  listCategoria2: [],
  listCategoria3: [],
  listCategoria4: [],
  listCategoria5: [],
  listCategoria6: [],
  listCategoria7: [],
  listCategoria8: [],
  listCategoria9: [],
  listCategoria10: [],
  listCategoria11: [],
  listCategoria12: [],
  faixaEtaria: [],
  percentualDesconto: [],
  qtdeComprasInicio: null,
  qtdeComprasFim: null,
  valorComprasInicio: null,
  valorComprasFim: null,
  ticketMedioInicio: null,
  ticketMedioFim: null,
  diasCadastroInicio: "",
  diasCadastroFim: "",
  diasCompraInicio: "",
  diasCompraFim: "",
  cashbackInicio: null,
  cashbackFim: null,
  dataInicioVencimentoCashback: null,
  dataFimVencimentoCashback: null,
  diasVencimentoCashback: [],
  selectedStores: [],
  dataCadastroInicio: null,
  dataCadastroFim: null,
  dataCompraInicio: null,
  dataCompraFim: null,
  telefone: null,
  email: null,
  endereco: null,
  aniversarioHoje: 0,
  aniversarioMes: 0,
  canalPreferecia: null,
  canalAceito: null,
  celular: null,
  genre: null,
  status: null,
  eCliente: null,
  termometro: null,
  potenciaisConsumidores_mesAtual: 1,
  potenciaisConsumidores_mesAnterior: 1,
  tipoCampanha: null,
  sensibilidade_sms: null,
  sensibilidade_email: null,
  sensibilidade_push: null,
  sensibilidade_whatsapp: null,

  changeToRefetch: 0,
};

export default STATIC_FILTER;
